export default __webpack_public_path__ + "static/media/block-filled.01d80650.svg";